(function ($) {
    "use strict";

    let ajaxWork = false;
    $('.js-article-details').on('click', function(event) {
        let id = $(this).data('id');

        event.preventDefault();
        event.stopPropagation();

        previewArticle(id);

        return false;
    });

    function previewArticle(id) {
        if (ajaxWork) {
            return false;
        }

        ajaxWork = true;

        $.ajax({
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", $('meta[name="csrf-token"]').attr('content'));
            },
            type      : "POST",
            url       : window.ajaxUrls.contentArtDts + id,
            success   : function (data) {
                ajaxWork = false;
                $("#exampleArticleModal .modal-body").html(data.content);
                $("#exampleArticleModal").modal("show");
            },
            error     : function (data) {
                ajaxWork = false;
                let errors = $.parseJSON(data.responseText);
                if (typeof errors.message !== "undefined" && errors.message != "") {
                    alert(errors.message);
                }
            }
        });
    }

    if ((location.hash).indexOf('article-') !== false) {
        let hashes = location.hash.split('article-');
        if (hashes[1] > 0) {
            let index = parseInt(hashes[1], 10) - 1;
            previewArticle($('.js-article-details[data-index='+index+']').data('id'));
        }
    }

    $('.faq-item__answer').on('show.bs.collapse', function () {
        $(this).closest('.faq-item').addClass('is-active')
    }).on('hidden.bs.collapse', function () {
        $(this).closest('.faq-item').removeClass('is-active')
    });

    $('.js-get-started-cm').on('click', function(event) {
        event.stopPropagation();
        event.preventDefault();

        location.href = $('[type=radio][name=tool]:checked').val();
    });

    function showFirstContentMachineModal() {
        if (window.userViewFirstModal) {
            return true;
        }

        if (!window.loggedIn) {
            return;
        }

        window.appEvents.contentMachineWelcome();

        $.ajax({
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", $('meta[name="csrf-token"]').attr('content'));
            },
            type      : 'POST',
            url       : window.ajaxUrls.usrSettingUpd + 'behavior',
            dataType  : 'json',
            data      : {
                is_first_modal_view: 1,
            },
            success   : function (data) {
                $('#modal-first-content-machine').modal('show');
            },
            error     : function (data) {
                console.log(data);
            }
        });
    }

    showFirstContentMachineModal();

})(jQuery);
